import { useState } from "react";
import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, MessagesSquare, ClipboardList, BookHeart, Newspaper, Image, FileText, Users, Settings, UserCog, LogOut, Menu, Mail, ExternalLink, ScrollText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ROLE_LABEL = { super_admin: "Super-admin", editor_ong: "Éditeur ONG", editor_association: "Éditeur Association" };

const LINKS = [
  ["/admin", "Tableau de bord", LayoutDashboard],
  ["/admin/messages", "Messages", MessagesSquare],
  ["/admin/candidatures", "Candidatures", ClipboardList],
  ["/admin/livre-dor", "Livre d'or", BookHeart],
  ["/admin/newsletter", "Newsletter (inscrits)", Mail],
  ["/admin/lettres", "Lettres d'information", ScrollText],
  ["/admin/articles", "Articles", Newspaper],
  ["/admin/galerie", "Galerie", Image],
  ["/admin/documents", "Documents PDF", FileText],
  ["/admin/bureau", "Bureau exécutif", Users],
  ["/admin/parametres", "Paramètres & Ma Leba", Settings, true],
  ["/admin/utilisateurs", "Utilisateurs", UserCog, true],
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  if (user === null) return <p className="p-10">Chargement…</p>;
  if (!user) return <Navigate to="/admin/login" replace />;
  const universe = user.role === "editor_association" ? "association" : "ong";
  return (
    <div data-universe={universe} className="flex min-h-screen bg-paper">
      <aside className={`fixed inset-y-0 left-0 z-40 w-64 transform bg-ink text-white transition-transform lg:static lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`} data-testid="admin-sidebar">
        <div className="border-b border-white/10 p-5">
          <p className="font-display text-2xl font-bold uppercase">Ma Leba</p>
          <p className="text-xs text-gold">{ROLE_LABEL[user.role]} · {user.email}</p>
        </div>
        <nav className="space-y-0.5 p-3" aria-label="Administration">
          {LINKS.filter((l) => !l[3] || user.role === "super_admin").map(([to, label, Icon]) => (
            <NavLink key={to} to={to} end={to === "/admin"} onClick={() => setOpen(false)} data-testid={`admin-nav-${to.split("/")[2] || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-u text-white" : "text-white/75 hover:bg-white/10"}`}>
              <Icon className="h-4 w-4" aria-hidden="true" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-1 border-t border-white/10 p-3">
          <Link to="/" className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-white/75 hover:bg-white/10" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /> Voir le site</Link>
          <button onClick={logout} className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm text-white/75 hover:bg-white/10" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Déconnexion</button>
        </div>
      </aside>
      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-3 border-b bg-white p-3 lg:hidden">
          <button onClick={() => setOpen(true)} aria-label="Menu" data-testid="admin-menu-toggle"><Menu className="h-6 w-6" /></button>
          <span className="font-display text-lg font-bold uppercase">Back-office</span>
        </div>
        <main className="p-4 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
